import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { SOARResources, binti } from "../services/soar";
import FloatingInput from "../common/FloatingInput";

function NewResidenceModal({ data, setData, show, handleSave, onHide }) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    // getPUs();
    getStates();
  }, [data.type]);

  // const getPUs = async () => {
  //   const resp = await getProgramUnits(
  //     JSON.parse(localStorage.getItem("safyInfo")).user.safyInfo
  //       .BusinessUnitIdName
  //   );
  //   const options = resp
  //     .filter(
  //       (unit) =>
  //         !unit.ccx_expdate &&
  //         unit.ccx_programtype["@name"] ===
  //           (data.type === "FosterHome" ? "TFC" : "Independent Living")
  //     )
  //     ?.map((unit) => ({
  //       _id: unit.ccx_unitid.replaceAll("{", "").replaceAll("}", ""),
  //       name: unit.ccx_name,
  //       state: unit["facility.ccx_agency"]["@name"],
  //     }));
  //   setOptions(options);
  // };
  const getBintiHomeData = async (id) => {
    const resp = await binti({
      command: "query",
      keyword: "byid",
      ids: [id],
    });
    return resp;
  };

  const getStates = async () => {
    const resp = await SOARResources({
      command: "query",
      environment: "SOARQueryBase",
      resource: "company",
      keyword: "viewall",
    });

    if (resp.code === "success") {
      const options = resp.data.map((company) => ({
        _id: company.id,
        name: company.name,
      }));
      setOptions(options);
    }
  };

  return (
    <Modal show={show} onHide={onHide} animation={false} size="lg">
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title>Home Information</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-safy2-4">
        {data.type !== "FosterHome" && (
          <>
            <FloatingInput
              className="card-safy mb-2"
              label="Address"
              name="Address"
              value={data.address}
              onChange={(e) => setData({ ...data, address: e.target.value })}
            />
            <FloatingInput
              className="card-safy mb-2"
              label="City"
              name="City"
              value={data.city}
              onChange={(e) => setData({ ...data, city: e.target.value })}
            />
            <FloatingInput
              className="card-safy mb-2"
              label="State"
              name="State"
              value={data.state}
              onChange={(e) => setData({ ...data, state: e.target.value })}
            />
            <FloatingInput
              className="card-safy mb-2"
              label="Zip Code"
              name="zip"
              value={data.zip}
              onChange={(e) => setData({ ...data, zip: e.target.value })}
            />
          </>
        )}
        {data.type === "FosterHome" && (
          <FloatingInput
            name="externalIdentifier"
            label="Binti ID"
            value={data.externalIdentifier}
            onChange={(e) =>
              setData({ ...data, externalIdentifier: e.target.value })
            }
          />
        )}
        <FloatingInput
          type="select"
          className="card-safy mb-2"
          label="State"
          name="State"
          value={data.company}
          options={options}
          onChange={(e) => {
            setData({
              ...data,
              company: e.target.value,
              companyName:
                options.find((option) => option._id === e.target.value)?.name ||
                "",
            });
          }}
        />
      </Modal.Body>
      <Modal.Footer className="bg-safy2-4">
        <button
          className="btn btn-sm btn-success"
          onClick={async () => {
            const obj = { ...data };
            if (data.type === "FosterHome" && data.externalIdentifier) {
              await getBintiHomeData(data.externalIdentifier).then((resp) => {
                if (resp.code === "success" && resp.data.length > 0) {
                  obj.name = resp.data[0].homedata[0]["application-home-name"];
                  handleSave(obj).then((response) => {
                    if (response.code === "success") {
                      toast.success("Saved successfully!");
                      setData(obj);
                      onHide(response);
                    } else {
                      toast.error(response.message);
                    }
                  });
                } else {
                  toast.error("Binti ID not found.");
                }
              });
            }
          }}
          disabled={
            data.type === "FosterHome" &&
            (data.externalIdentifier === "" || data.company === "")
          }
        >
          Save
        </button>
        <div className="btn btn-sm btn-danger" onClick={() => onHide()}>
          Cancel
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default NewResidenceModal;
